exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.form-control[data-v-e5612886]::placeholder{color:#bbb}div.alert[data-v-e5612886]{font-size:1.2rem;margin-top:1rem;margin-bottom:0}.loader[data-v-e5612886]{width:48px;height:48px;display:inline-block;position:relative;border:3px solid;border-color:#de3500 #0000 #fff;border-radius:50%;box-sizing:border-box;animation:1s rotate-data-v-e5612886 linear infinite}.loader[data-v-e5612886]:after,.loader[data-v-e5612886]:before{content:\"\";top:0;left:0;position:absolute;border:10px solid transparent;border-bottom-color:#fff;transform:translate(-10px,19px) rotate(-35deg)}.loader[data-v-e5612886]:after{border-color:#de3500 #0000 #0000;transform:translate(32px,3px) rotate(-35deg)}@keyframes rotate-data-v-e5612886{to{transform:rotate(1turn)}}.loader[data-v-e5612886]{transform:scale(50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e5612886","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Connect.vue
// module id = 56
// module chunks = 0